import DhlClaimDetail from './DhlClaimDetail';

export default DhlClaimDetail;
